import Links from '@/shared/constants/navegacao';
import { FaEnvelopeOpenText } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function VerifiqueEmail() {

  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-4 mt-5">
      <div className="rounded-3xl p-6 max-w-md w-full text-center">
        <FaEnvelopeOpenText size={50} className="text-primary mb-4" />
        <h2 className="text-2xl font-semibold mb-2">Verifique seu e-mail</h2>
        <p className="text-muted mb-5">
          Se o CPF estiver cadastrado, enviaremos o link de acesso para o e-mail em instantes.
          <br /> Confira sua caixa de entrada (e também a de spam).
        </p>
        <Link className="btn btn-primary w-10" to={Links.Auth_Obter_Token}>
          Voltar ao Login
        </Link>
      </div>
    </div>
  );
}
